package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "ms")
val MsStrings = Strings(
    analyzer = "Penganalisis",
    appreciationOverview = "Gambaran Keseluruhan Penghargaan",
    chartLegendInterest = "Faedah",
    chartLegendPrincipal = "Pokok",
    chartXaxisMonths = "Bulan",
    chartYaxisPayment = "Bayaran",
    code = "ms",
    costOfCredit = "Kos Kredit",
    creditDealAnalyzerDescription = "Masukkan butiran pinjaman anda untuk menerima analisis komprehensif tawaran kredit anda. Penganalisis kami menilai metrik utama untuk membantu Anda memahami kos sebenar pinjaman anda và membuat keputusan termaklum.",
    detailsGoodRateLongTerm = "Kadar yang baik tetapi tempoh yang panjang menyebabkan jumlah kos yang tinggi.",
    detailsHighApr = "APR tinggi. ",
    detailsHighInterestCost = "Jumlah kos faedah yang tinggi.",
    detailsHighRateShortTerm = "Kadar tinggi tetapi tempoh pendek mengekalkan jumlah kos rendah.",
    detailsLowApr = "APR rendah. ",
    detailsLowInterestCost = "Jumlah kos faedah yang rendah.",
    discountsTradeIn = "Diskaun / Tukar Beli",
    displayName = "Bahasa Melayu",
    distribution = "Pengagihan",
    downPayment = "Bayaran Muka",
    effectiveApr = "APR",
    headerBalance = "Baki",
    headerDate = "Tarikh",
    headerInterest = "Faedah",
    headerMonth = "#",
    headerPayment = "Bayaran",
    headerPrincipal = "Pokok",
    hideDetails = "Sembunyikan Butiran",
    interest = "Faedah",
    invalidData = "Data Tidak Sah",
    loanAmountSupportingText = "Jumlah pinjaman, termasuk sebarang kos tambahan.",
    loanDetails = "Butiran Pinjaman",
    paymentSupportingText = "Anggaran bayaran bulanan anda.",
    paymentComposition = "Komposisi Bayaran",
    percentSymbol = "%",
    principal = "Pokok",
    ratingBad = "Tawaran Buruk",
    ratingExcellent = "Tawaran Cemerlang",
    ratingFair = "Tawaran Adil",
    ratingGood = "Tawaran Baik",
    ratingPoor = "Tawaran Lemah",
    schedule = "Jadual",
    showDetails = "Tunjukkan Butiran",
    summaryBad = "Sangat tidak menguntungkan, elakkan jika boleh.",
    summaryExcellent = "Keadaan kewangan yang cemerlang.",
    summaryFair = "Keadaan adil, pertimbangkan untuk berunding.",
    summaryGood = "Keadaan baik, standard untuk pasaran.",
    summaryPoor = "Keadaan lemah, kos atau kadar tinggi.",
    totalPaid = "Jumlah Dibayar",
    lockTaxRate = "Kunci Kadar Cukai",
    unlockTaxRate = "Buka Kunci Kadar Cukai",
    currencySymbol = "RM",
    currency = "Mata Wang",
    totalCreditAmount = "Jumlah Kredit",
    taxAmount = "Jumlah Cukai/Potongan",
    netAmountDisbursed = "Jumlah Bersih Dibayar",
    years = "Tahun",
    loanTermTotalMonths = "Tempoh Pinjaman (Bulan)",
    monthlyInstallment = "Ansuran Bulanan",
    principalInstallment = "Ansuran Pokok",
    otherFees = "Yuran Lain",
    insuranceCost = "Premium Insurans",
    aprc = "Kadar Peratusan Tahunan Caj (APRC)",
    totalAmountPayable = "Jumlah Perlu Dibayar",
    prepaidFeeFixed = "Yuran Pemprosesan (Jumlah Tetap)",
    prepaidFeePercentage = "Yuran Pemprosesan (Peratusan)",
    months = "Bulan",
    description = "Penganalisis ini membantu anda menilai sama ada tawaran pinjaman menguntungkan anda. Tidak seperti kalkulator standard, ia tidak memerlukan input kadar faedah. Seterusnya, ia mengira APR và jumlah kos kredit berdasarkan bayaran và yuran, memberikan penarafan tawaran và carta terperinci.",
    agree = "Setuju",
    information = "Maklumat",
    errorCalculationOverflow = "APR terlalu tinggi, limpahan pengiraan.",
    errorTotalPaymentIsLessThanLoanAmount = "Jumlah yang diterima kurang daripada jumlah pinjaman.",
    errorDivisionByZero = "Pembahagian dengan sifar",
    errorNegativeResult = "Hasil negatif",
    errorRateTooHigh = "Kadar terlalu tinggi",
    errorCalculation = "Sila masukkan data yang betul",
    close = "Tutup",

    hi = "Hai",
    guest = "Tetamu",
    account = "Akaun",
    signInWithGoogle = "Log masuk dengan Google",
    signOut = "Log keluar",
    settings = "Tetapan",
    about = "Mengenai",
    privacyPolicy = "Dasar Privasi",
    termsOfService = "Syarat Perkhidmatan",
    language = "Bahasa",

    theme = "Tema",
    light = "Terang",
    dark = "Gelap",
    system = "Sistem",
    toggleExpand = "Kembangkan/Kuncupkan",
)
